import { render } from "./CreateChallenge.vue?vue&type=template&id=1a87a445&scoped=true"
import script from "./CreateChallenge.vue?vue&type=script&lang=js"
export * from "./CreateChallenge.vue?vue&type=script&lang=js"

import "./CreateChallenge.vue?vue&type=style&index=0&id=1a87a445&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a87a445"]])

export default __exports__